"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunicationType = void 0;
var CommunicationType;
(function (CommunicationType) {
    CommunicationType["Letter"] = "Letter";
    CommunicationType["Email"] = "Email";
})(CommunicationType = exports.CommunicationType || (exports.CommunicationType = {}));
//# sourceMappingURL=CommunicationType.js.map